import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { logger } from '@/utils/logger';

// Types pour Capacitor
declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Capacitor?: any;
  }
}

export const useDeepLinkHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Gérer les deep links pour l'authentification sur mobile
    const handleDeepLink = (url: string) => {
      logger.debug('🔗 Deep link reçu');
      
      if (url.includes('octoveto://auth/callback')) {
        // Extraire les paramètres de l'URL
        const urlParams = new URLSearchParams(url.split('#')[1] || '');
        const accessToken = urlParams.get('access_token');
        const refreshToken = urlParams.get('refresh_token');
        
        if (accessToken && refreshToken) {
          logger.debug('🔑 Tokens trouvés dans le deep link');
          
          // Définir la session avec les tokens reçus
          supabase.auth.setSession({
            access_token: accessToken,
            refresh_token: refreshToken
          }).then(({ error }) => {
            if (error) {
              logger.error('❌ Erreur lors de la définition de session:', error.message);
            } else {
              logger.debug('✅ Session définie avec succès via deep link');
              // Rediriger vers la page d'accueil
              navigate('/', { replace: true });
            }
          });
        }
      }
    };

    // Vérifier si on est dans Capacitor
    if (typeof window !== 'undefined' && window.Capacitor) {
      // Écouter les événements de deep link
      import('@capacitor/app').then(({ App }) => {
        App.addListener('appUrlOpen', (event: { url: string }) => {
          handleDeepLink(event.url);
        });
        
        // Vérifier si l'app a été ouverte avec un deep link
        App.getLaunchUrl().then((result) => {
          if (result?.url) {
            handleDeepLink(result.url);
          }
        });
      }).catch((error) => {
        logger.debug('Capacitor App plugin non disponible');
      });
    }

    return () => {
      // Cleanup si nécessaire
      if (typeof window !== 'undefined' && window.Capacitor) {
        import('@capacitor/app').then(({ App }) => {
          App.removeAllListeners();
        }).catch(() => {
          // Ignore cleanup errors
        });
      }
    };
  }, [navigate]);
};
